export const formConstants = {
  ROLE_ANSWERS: ["Marketing", "Product", "E-Commerce", "Other"],
  USECASE_ANSWERS: [
    "Ask ad-hoc data related questions",
    "Quickly generate visualizations",
    "Combine different data sources",
    "Generate complex SQL queries",
    "Other",
  ],
};
